<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your retirement target</span>
        </div>
      </div>
    </div>

    <section>
      <p class="section-content">See the effect altering your desired income or your retirement age can have on your estimated retirement income. </p>
      <retirement-target-inputs></retirement-target-inputs>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    /* eslint-disable global-require */
    RetirementTargetInputs: require('../../inputs/RetirementTargetInputs').default,
    /* eslint-enable global-require */
  },
};
</script>
